(function () {
  'use strict';

  angular.module('sempraWebapp').factory('sempraUsersActions', sempraUsersActionsFactory);

  /** @ngInject */
  function sempraUsersActionsFactory ($q, api, dispatcher, ActionTypesEnum) {
    return {
      getSempraUsers: getSempraUsers,
      searchSempraUsers: searchSempraUsers,
      searchSempraUsersByTelephone: searchSempraUsersByTelephone,
      searchSavingsUsers: searchSavingsUsers
    };

    function getSempraUsers () {
      var deferred = $q.defer();

      api.getSempraUsers().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function searchSempraUsers (searchTerm) {
      var deferred = $q.defer();

      api.searchSempraUsers(searchTerm).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function searchSempraUsersByTelephone (searchTerm) {
      var deferred = $q.defer();

      api.searchSempraUsersByTelephoneNumber(searchTerm).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function searchSavingsUsers (searchTerm) {
      var deferred = $q.defer();

      api.searchSavingsUsers(searchTerm).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();
